export default __webpack_public_path__ + "static/media/CLX.e200bd29.png";